import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Grid, TextField, MenuItem, FormControl, InputLabel, Select, Button, Avatar } from "@mui/material";
import Autocomplete from '@mui/material/Autocomplete';
import useAutocomplete from '@mui/material/useAutocomplete';
import "react-datepicker/dist/react-datepicker.css"; // Add this line
import { Colors, useStyles } from '../../assets/styles.js';
import logo_icon from '../../assets/images/logo_icon.png'
import * as UserActions from '../../redux/actions/userAction.js';

const AddUser = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [userDetails, setUserDetails] = useState({ firstName: '', lastName: '', email: '', contact: '', currentRole: '', password: '', userStatus: '' });
  const [inputFieldError, setInputFieldError] = useState({ name: "Please Provide Name", email: "Please Provide Email" });
  const [userImage, setUserImage] = useState({ file: logo_icon, bytes: "" });

  //* Handle Input Field : Error
  const handleInputFieldError = (input, value) => {
    setInputFieldError((prev) => ({ ...prev, [input]: value }))
  }

  //* Handle Input Field : Data
  const handleInputField = (e) => {
    const { name, value } = e.target;
    setUserDetails({ ...userDetails, [name]: value });
  };

  //* Handle User Image
  const handleUserImage = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setUserImage({
        file: URL.createObjectURL(e.target.files[0]),
        bytes: e.target.files[0],
      });
    }
  };

  //! Handle Submit - Creating User
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("User Data :: ", { ...userDetails, userImage })
    const { firstName, lastName, contact, email, currentRole, password, userStatus } = userDetails;

    let formData = new FormData()
    formData.append("firstName", firstName)
    formData.append("lastName", lastName);
    formData.append("phone", contact);
    formData.append("email", email);
    formData.append("currentRole", currentRole);
    formData.append("password", password);
    formData.append("userStatus", userStatus);
    formData.append("profileImage", userImage.bytes);

    const payload = {
      data: formData,
      onComplete: () => navigate("/user")
    }

    //! Dsipatching API for Creating User
    dispatch(UserActions.createUser(payload))
  };

  return (

    <>
      <div style={{ padding: "20px", backgroundColor: "#fff", marginBottom: "20px", boxShadow: '0px 0px 5px lightgrey', borderRadius: "10px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "30px", fontFamily: 'Philosopher', backgroundColor: "#fff" }}>
          <div style={{ fontSize: "20px", fontWeight: "600", color: "#667284" }}>Add User</div>
          <div onClick={() => navigate("/user")} style={{ fontWeight: "600", backgroundColor: "#164E62", color: "#fff", padding: "5px 10px", borderRadius: "5px", cursor: "pointer", fontSize: "14px" }}>Display</div>
        </div>

        <Grid container sx={{ alignItems: "center" }} spacing={3}>
          <Grid item lg={6} md={6} sm={12} xs={12} >
            <TextField
              label="First Name" variant='outlined' fullWidth
              name='firstName'
              value={userDetails?.firstName}
              onChange={handleInputField}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <TextField
              label="Last Name" variant='outlined' fullWidth
              name='lastName'
              value={userDetails?.lastName}
              onChange={handleInputField}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <TextField
              label="Email" variant='outlined' fullWidth
              name='email'
              value={userDetails?.email}
              onChange={handleInputField}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <TextField
              label="Contact" variant='outlined' fullWidth
              name='contact'
              value={userDetails?.contact}
              onChange={handleInputField}
            />
          </Grid>

          <Grid item lg={1} sm={6} md={6} xs={6} >
            <Avatar
              color={Colors.primaryDark}
              src={userImage.file}
              style={{ width: 40, height: 40 }}
            />
          </Grid>
          <Grid item lg={5} sm={6} md={6} xs={6} className={classes.uploadContainer}   >
            <Grid component="label" className={classes.uploadImageButton}>
              Upload User Image
              <input onChange={handleUserImage} hidden accept="image/*" type="file" />
            </Grid>
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <FormControl fullWidth>
              <InputLabel id="select-label">Current Role</InputLabel>
              <Select
                label="Current Role" variant="outlined" fullWidth
                name='currentRole'
                value={userDetails?.currentRole}
                onChange={handleInputField}
              >
                <MenuItem disabled>---Select Current Role---</MenuItem>
                <MenuItem value="student">Student</MenuItem>
                <MenuItem value="doctor">Postdoctoral Fellow</MenuItem>
                <MenuItem value="professor">Professor/Scientist/Lecturer/Teacher</MenuItem>
                <MenuItem value="corporate">Corporate Individual</MenuItem>
                <MenuItem value="other">Other</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <TextField
              label="Password" variant='outlined' fullWidth
              name='password'
              value={userDetails?.password}
              onChange={handleInputField}
            />
          </Grid>

          <Grid item lg={6} md={6} sm={12} xs={12} >
            <FormControl fullWidth>
              <InputLabel id="select-label">Select Status</InputLabel>
              <Select
                label="Select Status" variant="outlined" fullWidth
                name='userStatus'
                value={userDetails?.userStatus}
                onChange={handleInputField}
              >
                <MenuItem disabled>---Select Status---</MenuItem>
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Inactive">Inactive</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item>
            <div onClick={handleSubmit} style={{ fontWeight: "500", backgroundColor: "#164E62", color: "#fff", padding: "10px 20px", borderRadius: "5px", cursor: "pointer", fontSize: "15px" }}>Submit</div>
          </Grid>

        </Grid>
      </div>
    </>

  );
};

export default AddUser;